/* TENDON — load-more produktů (progressive enhancement nad {% paginate %} gridem).
   Tlačítko je reálný <a href="?page=N"> (crawlovatelné + funguje bez JS); s JS
   preventDefault + fetch připojí další stránku do #product-grid. Koexistuje s
   facet-filters (ten při změně filtru přerenderuje #filter-results včetně čerstvého
   <load-more-products>). URL se záměrně nemění — Shopify paginate nerenderuje
   kumulativně, číslované stránky zajišťují bookmarkovatelnost i crawl. */
if (!customElements.get('load-more-products')) {
  class LoadMoreProducts extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      // Když je aktivní JS a téma to žádá, skryj číslované stránkování (no-JS fallback).
      if (this.dataset.hideFallback === 'true') {
        const fallback = document.querySelector('[data-lm-fallback]');
        if (fallback) fallback.hidden = true;
      }

      this.status = this.querySelector('[data-lm-status]');
      this.addEventListener('click', (evt) => {
        const trigger = evt.target.closest('[data-lm-btn]');
        if (!trigger) return;
        evt.preventDefault();
        this.loadNext(trigger);
      });
    }

    async loadNext(link) {
      const url = link.getAttribute('href');
      if (!url || this.loading) return;
      this.loading = true;
      // Lokalizovaný text „načteno N produktů" pro čtečku — server ho předrenderoval
      // (t filtr, count = počet produktů příští stránky) do data-loaded-text tlačítka.
      const loadedText = link.getAttribute('data-loaded-text') || '';
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const grid = document.getElementById('product-grid');
        const incoming = Array.from(tmpl.content.querySelectorAll('#product-grid > li'));
        if (!grid || incoming.length === 0) { this.exhaust(link); return; }

        // Jedno připojení do DOM (bez N reflowů).
        const frag = document.createDocumentFragment();
        incoming.forEach((li) => frag.appendChild(li));
        const firstNew = frag.firstElementChild;
        grid.appendChild(frag);

        // Progress počítá jen produktové <li> — promo bannery ([data-tdn-banner]) se nepočítají.
        const shownCount = grid.querySelectorAll(':scope > li:not([data-tdn-banner])').length;
        const total = Number(this.dataset.total) || shownCount;
        const fill = this.querySelector('[data-lm-fill]');
        if (fill) fill.style.width = `${Math.min((shownCount / total) * 100, 100)}%`;

        // Aktualizuj sebe z čerstvého load-more elementu příští stránky
        // (texty jsou server-rendered přes t filtr — JS žádné neskládá).
        const next = tmpl.content.querySelector('load-more-products');
        const nextLink = next ? next.querySelector('[data-lm-btn]') : null;
        if (nextLink && nextLink.getAttribute('href')) {
          link.setAttribute('href', nextLink.getAttribute('href'));
          if (nextLink.getAttribute('data-loaded-text')) {
            link.setAttribute('data-loaded-text', nextLink.getAttribute('data-loaded-text'));
          }
          this.swapText('[data-lm-label]', next);
          this.swapText('[data-lm-progress]', next);
        } else {
          this.exhaust(link, grid, total, fill);
        }

        // Fokus na první novou kartu — klávesnice/čtečka neztratí místo.
        if (firstNew) {
          firstNew.setAttribute('tabindex', '-1');
          firstNew.focus({ preventScroll: true });
        }
        // Stručné oznámení pro čtečku, mimo focus event.
        if (this.status && loadedText) {
          window.setTimeout(() => { this.status.textContent = loadedText; }, 150);
        }
      } catch (err) {
        if (this.status) this.status.textContent = this.dataset.errorText || '';
      } finally {
        if (link.isConnected) {
          link.classList.remove('is-loading');
          link.removeAttribute('aria-busy');
        }
        this.loading = false;
      }
    }

    swapText(selector, sourceEl) {
      const target = this.querySelector(selector);
      const source = sourceEl.querySelector(selector);
      if (target && source) target.textContent = source.textContent;
    }

    // Poslední stránka — dorovnej postup a odeber tlačítko z Tab pořadí.
    // Finální text „vše zobrazeno" je server-rendered (t filtr) v data-complete-text.
    exhaust(link, grid, total, fill) {
      if (grid && total) {
        const prog = this.querySelector('[data-lm-progress]');
        if (prog && this.dataset.completeText) prog.textContent = this.dataset.completeText;
        if (fill) fill.style.width = '100%';
      }
      if (link) link.remove();
    }
  }

  customElements.define('load-more-products', LoadMoreProducts);
}
